let wishlistGroups = JSON.parse(localStorage.getItem("wishlistGroups")) || { groups: [] };

function saveGroups() {
  localStorage.setItem("wishlistGroups", JSON.stringify(wishlistGroups));
}

function openGroupModal(item) {
  let modal = document.getElementById("wishlist-group-modal");
  let select = document.getElementById("wishlist-group-select");
  let input = document.getElementById("new-group-name");

  // Reset
  select.innerHTML = '<option value="">-- Choose a group --</option>';
  input.value = "";

  wishlistGroups.groups.forEach(group => {
    let opt = document.createElement("option");
    opt.value = group.id;
    opt.textContent = group.name;
    select.appendChild(opt);
  });

  modal.style.display = "block";

  document.getElementById("wishlist-group-save").onclick = function() {
    let groupId = select.value;
    let newGroupName = input.value.trim();
    let targetGroup;

    if (newGroupName) {
      targetGroup = { id: "grp" + Date.now(), name: newGroupName, items: [] };
      wishlistGroups.groups.push(targetGroup);
    } else if (groupId) {
      targetGroup = wishlistGroups.groups.find(g => g.id === groupId);
    }

    if (targetGroup) {
      targetGroup.items.push(item);
      saveGroups();
    }

    modal.style.display = "none";
  };

  document.getElementById("wishlist-group-cancel").onclick = function() {
    modal.style.display = "none";
  };
}

// Hook into XB Wishlist add event
document.addEventListener("xb:wishlist:add", function(e) {
  let item = e.detail.item; // SKU or product ID
  openGroupModal(item);
});
